//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.MyBusiness.PolicyDetails',
                {
                    url: '/PolicyDetails/{policyGuid}',
                    component: 'policyDetailsComponent',
                    params: {
                        policyDetails: null
                    },
                });
        }
    ]);

    app.component('policyDetailsComponent', {
        templateUrl: 'App.Portal/States/MyBusiness/PolicyDetails/PolicyDetails.template.html',
        controller: 'PolicyDetailsController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
        }
    });

    app.controller('PolicyDetailsController', PolicyDetailsController);

    PolicyDetailsController.$inject = ["$filter", "newBusinessReportsApi", "$q", "$state", "$stateParams"];

    function PolicyDetailsController($filter, newBusinessReportsApi, $q, $state, $stateParams) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                },
                viewUpdates: false,
                policy: {},
                filterStageById: filterStageById
                //downloadFile: downloadFile,
            });

        function filterStageById(stageId) {
            var stage = $ctrl.policy.StageHistory.filter(function (row) { return row.PolicyStageId === stageId; });
            if (stage.length > 0) {
                return stage[0];
            }
            return false;
        }

        //function downloadFile(data) {
        //    var f = document.createElement("a");
        //    f.id = "tmpDownload-" + ++downloadIncrement;
        //    document.body.appendChild(f);
        //    f.style = "display: none";

        //    var fUrl = window.URL.createObjectURL(data);
        //    f.href = fUrl;
        //    f.download = $ctrl.UI.ShowRequirements ? "RequirementData.xlsx" : "PolicyData.xlsx";
        //    f.click();

        //    setTimeout(function () {
        //        var el = document.getElementById(f.id);
        //        document.body.removeChild(el);
        //        window.URL.revokeObjectURL(fUrl);
        //    },
        //        100);
        //}

        $ctrl.$onInit = function () {
            $ctrl.policyGuid = $stateParams.policyGuid;
            $ctrl.policyDetails = $stateParams.policyDetails;
            //console.log("policyDetails", $ctrl.policyDetails);

            //If no policy details, redirect to policylist
            if (!$stateParams.policyDetails) { $state.go('Portal.MyBusiness.PolicyList') }
            else if ($ctrl.policyGuid) {
                $ctrl.ui.loading = true;
                const promises = [
                    newBusinessReportsApi.getPolicyDetailsByGuid($ctrl.policyGuid),
                    newBusinessReportsApi.getPolicyFundingByGuid($ctrl.policyGuid),
                    newBusinessReportsApi.getPolicySuitabilityStatusByGuid($ctrl.policyGuid),
                    newBusinessReportsApi.getAgentUploadsByGuid($ctrl.policyGuid),
                ];
                $q.all(promises)
                    .then(function (responses) {
                        console.log(responses);
                        $ctrl.policy = responses[0];
                        $ctrl.policy.Funding = responses[1];
                        $ctrl.policy.Suitability = responses[2];
                        $ctrl.policy.AgentUploads = responses[3];
                        //$ctrl.ui.viewUpdates = !$ctrl.policy.CarrierRequirements.length; //if no latest req, show past updates
                    })
                    .then(function () {
                        $ctrl.policy.UpdateList = [];
                        $ctrl.policy.FundingAmountTotal = 0;
                        $ctrl.policy.FundingIssuedTotal = 0;
                        $ctrl.policy.FundingTotal = 0;
                        $ctrl.policy.StageHistoryObject = [
                            $ctrl.filterStageById(1), //Application Signed
                            $ctrl.filterStageById(2), //Received at FIG
                            $ctrl.filterStageById(3), //Submitted to Carrier
                            $ctrl.filterStageById(4), //Pending
                            $ctrl.filterStageById(5), //Approved - Life and LTC
                            $ctrl.filterStageById(6), //Issued
                            $ctrl.filterStageById(7), //Inforce
                            $ctrl.filterStageById(8), //Cancelled
                        ]
                        var promise = [];
                        if ($ctrl.policyDetails.IsVariable) {
                            promise.push(newBusinessReportsApi.getVariablePolicyCaseStatusHistoryByGuid($ctrl.policyGuid));
                        } else {
                            promise.push(newBusinessReportsApi.getPolicyCaseStatusHistoryByGuid($ctrl.policyGuid));
                        }
                        $q.all(promise)
                            .then(function (response) {
                                $ctrl.policy.CaseHistory = response[0]; //array of case updates with notes
                                _.forEach(response[0], function (update) {
                                    update.Date = update.ModifiedOn;
                                    update.Type = "CaseStatusUpdate";
                                    $ctrl.policy.UpdateList = $ctrl.policy.UpdateList.concat(update);

                                    _.forEach(update.Notes, function (note) {
                                        note.Type = "Note";
                                        note.Date = update.ModifiedOn;
                                        $ctrl.policy.UpdateList = $ctrl.policy.UpdateList.concat(note);
                                    });
                                });
                            })
                        _.forEach($ctrl.policy.AgentUploads, function (update) {
                            update.Type = "Upload";
                            update.Date = update.CreatedOn;
                            $ctrl.policy.UpdateList = $ctrl.policy.UpdateList.concat(update);
                        });
                        _.forEach($ctrl.policy.Funding, function (row) {
                            row.IssuedPremiumAmount = !!row.IssuedPremiumAmount ? row.IssuedPremiumAmount : 0;
                            row.IsFullyIssued = !!row.Amount ? false : true;
                            $ctrl.policy.FundingAmountTotal += !!row.Amount ? row.Amount : 0;
                            $ctrl.policy.FundingIssuedTotal += !!row.IssuedPremiumAmount ? row.IssuedPremiumAmount : 0;
                            $ctrl.policy.FundingTotal += !!row.Amount ? row.Amount : row.IssuedPremiumAmount;
                        });
                    })
                    .catch(function (error) {
                        console.log(error.data);
                    })
                    .finally(function () {
                        $ctrl.policy.FundingFullyIssued = $ctrl.policy.FundingTotal !== 0 && $ctrl.policy.FundingTotal === $ctrl.policy.FundingIssuedTotal;
                        $ctrl.ui.loading = false;
                        //console.log($ctrl.policy);
                    })
            }
        };
    }
})(window.angular, window.app);